import ModuleList from "./List";
function Modules() {
  return (
    <div className="d-flex mt-4">
      {/* <h2 className="mb-4 mt-4">Modules</h2> */}
      <ModuleList/>

    </div>
  );
}
export default Modules;